import * as forge from 'node-forge';

export const CryptoHelper = class {
  private forge: any;
  constructor() {
    this.forge = null;
    this._init();
  }

  async _init() {
    try {
      this.forge = forge;
    } catch (error) {
      throw new Error('Failed to load node-forge');
    }
  }

  encrypt(data: string, token: string) {
    // Generate salt and derive key
    const salt = this.forge.random.getBytesSync(8);
    const key = this.forge.pkcs5.pbkdf2(token, salt, 1000, 32, this.forge.md.sha256.create());

    // Create and initialize cipher
    const iv = this.forge.random.getBytesSync(12);
    const cipher = this.forge.cipher.createCipher('AES-GCM', key);
    cipher.start({ iv, tagLength: 128 });

    // Encrypt data
    cipher.update(this.forge.util.createBuffer(data, 'utf8'));
    cipher.finish();

    // Combine elements and return base64
    const result = salt + iv + cipher.output.getBytes() + cipher.mode.tag.getBytes();
    return this.forge.util.encode64(result);
  }

  decrypt(encryptedData: string, token: string) {
    // Decode base64
    const data = this.forge.util.decode64(encryptedData);

    // Extract components
    const salt = data.slice(0, 8);
    const iv = data.slice(8, 20);
    const tag = data.slice(data.length - 16);
    const ciphertext = data.slice(20, data.length - 16);

    // Derive key and setup decipher
    const key = this.forge.pkcs5.pbkdf2(token, salt, 1000, 32, this.forge.md.sha256.create());
    const decipher = this.forge.cipher.createDecipher('AES-GCM', key);
    decipher.start({ iv, tag: this.forge.util.createBuffer(tag) });

    // Decrypt
    decipher.update(this.forge.util.createBuffer(ciphertext));
    if (!decipher.finish()) {
      throw new Error('Decryption failed');
    }

    return decipher.output.toString('utf8');
  }
};
